/**
 * `/settings/security` — the credential surfaces.
 *
 * One `RouteObject`, so the file is `security.route.tsx` (singular). No
 * `loader` performs a data read; the page component owns its reads.
 */
import type { RouteObject } from 'react-router-dom';

export const securitySettingsRoute: RouteObject = {
  path: 'settings/security',
  lazy: async () => {
    const { SecuritySettingsPage } = await import('./Security');
    return { Component: SecuritySettingsPage };
  },
};
